import { render, staticRenderFns } from "./userAdd.vue?vue&type=template&id=5098f0aa&scoped=true&"
import script from "./userAdd.vue?vue&type=script&lang=js&"
export * from "./userAdd.vue?vue&type=script&lang=js&"
import style0 from "./userAdd.vue?vue&type=style&index=0&id=5098f0aa&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5098f0aa",
  null
  
)

export default component.exports